import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';
import { get, merge } from 'lodash';
import { getStore } from 'store';
import { REDUCER } from 'constants/entity-names';

// get store
const store = getStore();

/*************************************************************/

/**
 * @type {class}
 * @desc MemberDetailsSavingsMailPrescriptionWidget defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { MemberDetailsSavingsMailPrescriptionWidgetService } from 'services/memberDetailsSavingsMailPrescriptionWidget';
 *
 * // create service instance and send/cancel request
 * const memberDetailsSavingsMailPrescriptionWidgetService = new MemberDetailsSavingsMailPrescriptionWidgetService();
 * const result = await memberDetailsSavingsMailPrescriptionWidgetService.fetchData( '<user-id>' ); // fetch data
 * memberDetailsSavingsMailPrescriptionWidgetService.cancel(); // cancel an active request
 */
export class MemberDetailsSavingsMailPrescriptionWidgetService extends HttpService {

    // make request and fetch data
    async fetchData( { url = {}, data = {} } = {} ) {

        // get ongoing call info from the redux store
        const callId = get( store.getState()[ REDUCER.CALL_STATE ], 'callId', null );
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data: merge( data, {
                    context: {
                        callId,
                    }
                } ),
            } );

            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.ERROR ),
                data: get( response, 'body.component', {} ),
            };
        } catch( errResponse ) {
            return this._errorFormatter( errResponse );
        }
    }

    // format error response
    _errorFormatter( errResponse ) {
        return errResponse; // some logic
    }
}
